import React from "react";
import { BarChart3, Table2 } from "lucide-react";

export type ViewMode = "timeline" | "grid";

export interface ViewToggleProps {
  currentView: ViewMode;
  onViewChange: (view: ViewMode) => void;
  className?: string;
}

const ViewToggle: React.FC<ViewToggleProps> = ({
  currentView,
  onViewChange,
  className = "",
}) => {
  const tabClass = (active: boolean) =>
    `flex min-w-[8.5rem] flex-1 items-center justify-center gap-2 whitespace-nowrap rounded-[10px] px-4 py-2.5 text-sm font-semibold transition-colors sm:min-w-[9.5rem] ${
      active ? "bg-brand text-surface" : "text-white/55 hover:bg-white/80"
    }`;

  return (
    <div
      className={`inline-flex w-full min-w-[17.5rem] max-w-md rounded-[14px] border border-white/10 bg-surface-elevated p-1 sm:min-w-[19rem] ${className}`}
      role="tablist"
      aria-label="Dashboard view"
    >
      <button
        type="button"
        role="tab"
        aria-selected={currentView === "timeline"}
        className={tabClass(currentView === "timeline")}
        onClick={() => onViewChange("timeline")}
      >
        <BarChart3 className="h-4 w-4 shrink-0" aria-hidden />
        Timeline
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={currentView === "grid"}
        className={tabClass(currentView === "grid")}
        onClick={() => onViewChange("grid")}
      >
        <Table2 className="h-4 w-4 shrink-0" aria-hidden />
        Grid
      </button>
    </div>
  );
};

export default ViewToggle;
